import { api } from '../../services/api';
import * as types from '../Constants';
import { HIDE_UNHIDE_VISA_TYPE_SUCCESS, VISA_TYPE_WITH_HIDDEN_SUCCESS } from '../Constants';
import { getCached, setCache, removeCacheByPrefix } from '../../Common/apiCache';

export const getVisaType = (branchId) => {
  var selectedBranchId = localStorage.getItem('selectedBranchId');
  let id = selectedBranchId || branchId;
  const cacheKey = `visaType_${id}`;
  const cached = getCached(cacheKey);
  if (cached) {
    return (dispatch) =>
      Promise.resolve(dispatch({ type: types.VISA_TYPE_SUCCESS, payload: cached }));
  }
  const options = {
    url: 'v1/company/BranchVisaType/All/' + id,
  };
  options.types = [types.VISA_TYPE_SUCCESS, types.VISA_TYPE_FAILURE];
  const apiAction = api.get(options);
  return (dispatch) =>
    apiAction(dispatch).then((result) => {
      if (result && result.payload) setCache(cacheKey, result.payload);
      return result;
    });
};

export const getVisaTypeWithHidden = () => {
  const options = {
    url: `v1/company/BranchVisaType/WithHidden/All`,
  };

  options.types = [types.VISA_TYPE_WITH_HIDDEN_SUCCESS, types.VISA_TYPE_WITH_HIDDEN_FAILURE];

  return api.get(options);
};

export const addVisaType = (data) => {
  removeCacheByPrefix('visaType_');
  const options = {
    url: 'v1/company/BranchVisaType',
  };

  options.types = [types.ADD_VISA_TYPE_SUCCESS, types.ADD_VISA_TYPE_FAILURE];

  return api.post(options, data);
};

export const hideUnhideVisaType = (data) => {
  const options = {
    url: 'v1/company/BranchVisaType/Hide',
  };

  options.types = [types.HIDE_UNHIDE_VISA_TYPE_SUCCESS, types.HIDE_UNHIDE_VISA_TYPE_FAILURE];

  return api.put(options, data);
};

export const hideUnhideVisaStatus = (data) => {
  const options = {
    url: 'v1/company/visastatus/Hide',
  };

  options.types = [types.HIDE_UNHIDE_VISA_STATUS_SUCCESS, types.HIDE_UNHIDE_VISA_STATUS_FAILURE];

  return api.put(options, data);
};

export const updVisaType = (data) => {
  removeCacheByPrefix('visaType_');
  const options = {
    url: 'v1/company/BranchVisaType',
  };

  options.types = [types.UPDATE_VISA_TYPE_SUCCESS, types.UPDATE_VISA_TYPE_FAILURE];

  return api.put(options, data);
};

export const getCountries = () => {
  const cached = getCached('countries');
  if (cached) {
    return (dispatch) =>
      Promise.resolve(dispatch({ type: types.GET_COUNTRIES_SUCCESS, payload: cached }));
  }
  const options = {
    url: 'v1/config/GetAllCountries',
  };
  options.types = [types.GET_COUNTRIES_SUCCESS, types.GET_COUNTRIES_FAILURE];
  const apiAction = api.get(options);
  return (dispatch) =>
    apiAction(dispatch).then((result) => {
      if (result && result.payload) setCache('countries', result.payload);
      return result;
    });
};

export const getBranchVisaCountries = () => {
  const options = {
    url: `v1/BranchCountryLinking/ByBranchId`,
  };

  options.types = [
    types.GET_BRANCH_VISA_COUNTRIES_SUCCESS,
    types.GET_BRANCH_VISA_COUNTRIES_FAILURE,
  ];

  return api.get(options);
};
